/* eslint-disable consistent-return */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-shadow */
import { distanceBetween, geohashForLocation } from 'geofire-common';
import * as Yup from 'yup';
import i18n from 'i18next';
import { fromAddress } from 'react-geocode';
import {
  collection,
  doc,
  getDoc,
  getDocs,
  orderBy,
  query,
  setDoc,
  where,
} from 'firebase/firestore';
import request from './request';
import { emptyFilterForm } from '../static/filter';
import { firestore } from '../config/firebase';
import { mexicoStates, peruStates, provinces, states } from '../static/states';
import dayjs from '../util/datetime';
import { COUNTRIES, genericTlds } from '../static/region-data';
export const filterByDistance = (location, flattenPostData) => {
  try {
    if (
      !location?.radius ||
      !flattenPostData ||
      !Array.isArray(flattenPostData)
    ) {
      return flattenPostData;
    }
    const center = [Number(location.lat), Number(location.lng)];

    const radiusInM = parseFloat(location?.radius) * 1609.34;
    const matchingPosts = [];

    for (const post of flattenPostData) {
      const { location } = post;

      const distanceInKm = distanceBetween(
        [Number(location.lat), Number(location.lng)],
        center,
      );
      const distanceInM = distanceInKm * 1000;
      if (distanceInM <= radiusInM) {
        matchingPosts.push({ ...post, distance: distanceInM });
      }
    }
    const result = matchingPosts?.sort(
      (itemA, itemB) => itemA.distance - itemB.distance,
    );
    return result;
  } catch (error) {
    throw new Error(error);
  }
};

export const getActiveFilterCount = (filterValues) => {
  const count = Object.keys(
    Object.keys(filterValues).reduce((acc, key) => {
      const value = filterValues[key];
      if (typeof value === 'string' && value !== emptyFilterForm[key]) {
        acc[key] = value;
      }
      if (
        Array.isArray(value) &&
        !value.every((item, index) => item === emptyFilterForm[key][index])
      ) {
        acc[key] = value;
      }
      return acc;
    }, {}),
  )?.length;
  return count;
};

export const removeString = (str, partToRemove) => {
  if (str?.includes(partToRemove)) {
    return str.replace(partToRemove, '');
  }
  return str;
};

export const generateFormDefaultValues = (fields = [], values) => {
  const defaultValues = {
    location: values
      ? values?.location
      : {
          name: '',
          lat: 0,
          lng: 0,
          zipCode: '',
        },
    includePhone: values ? values.includePhone : false,
    photos: values ? values?.photos : [],
  };

  fields?.forEach((field) => {
    const { name, type } = field;

    switch (type) {
      case 'select':
      case 'text':
      case 'textArea':
        defaultValues[name] = values ? values[name] : '';
        break;
      case 'number':
        defaultValues[name] = values ? values[name].toString() : '';
        break;
      case 'modal':
        defaultValues[name] = field.isMultiSelect
          ? values
            ? values[name]
            : []
          : values
            ? values[name]
            : '';
        break;
      // Add more cases for other field types as needed
      default:
        break;
    }
  });

  return defaultValues;
};

export const generateYupSchema = (fields, t) => {
  const schema = {
    location: Yup.object({
      zipCode: Yup.string(),
      name: Yup.string(),
      lat: Yup.number(),
      lng: Yup.number(),
      filteredAddress: Yup.string(),
    }).test({
      test: (d) => d?.zipCode || d?.filteredAddress,
      message: t ? t('validation.pleaseAddLocation') : 'Please add location',
    }),
    photos: Yup.array()
      .of(Yup.string())
      .test({
        message: t
          ? t('validation.selectAtLeast1Image')
          : 'Select at least 1 image',
        test: (images) => Object.keys(images).length >= 1,
      })
      .required(
        t ? t('validation.selectAtLeast1Image') : 'Select at least 1 image',
      ),
  };

  fields.forEach((field) => {
    const { name, type } = field;

    switch (type) {
      case 'number':
        if (name === 'year' || name === 'price') {
          schema[name] = Yup.number()
            .typeError(
              t ? t('validation.mustBeAValidNumber') : 'Must be a valid number',
            )
            .required(
              t
                ? t('validation.thisFieldIsRequired')
                : 'This field is required',
            );
        } else {
          schema[name] = Yup.string().typeError(
            t ? t('validation.mustBeAValidNumber') : 'Must be a valid number',
          );
        }
        break;
      case 'text':
      case 'textArea':
        if (name === 'model') {
          schema[name] = Yup.string()
            .trim()
            .required(
              t
                ? t('validation.thisFieldIsRequired')
                : 'This field is required',
            );
        } else {
          schema[name] = Yup.string().trim();
        }
        break;
      case 'select':
        if (name === 'bodyStyle') {
          schema[name] = Yup.string().required(
            t
              ? t('validation.atleastSelectOneOption')
              : 'At least select one option',
          );
        }
        break;
      case 'modal':
        if (name === 'make') {
          schema[name] = field.isMultiSelect
            ? Yup.array()
                .of(
                  Yup.string().required(
                    t ? t('validation.textRequired') : 'Text Required',
                  ),
                )
                .test({
                  message: t
                    ? t('validation.atleastSelectOneFeature')
                    : 'At least select one feature',
                  test: (arr) => arr.length !== 0,
                })
                .required(
                  t
                    ? t('validation.thisFieldIsRequired')
                    : 'This field is required',
                )
            : Yup.string().required(
                t
                  ? t('validation.thisFieldIsRequired')
                  : 'This field is required',
              );
        } else {
          schema[name] = field.isMultiSelect
            ? Yup.array().of(Yup.string())
            : Yup.string();
        }
        break;
      default:
        break;
    }
  });

  return Yup.object().shape(schema);
};
export const generateGuestId = () => {
  const id = JSON.parse(localStorage.getItem('@guestId'));
  if (id) {
    return id;
  }
  const generateId = `GuestId${Math.random().toString(14).slice(2)}`;
  localStorage.setItem('@guestId', JSON.stringify(generateId));
  return generateId;
};
export const getBlobFroUri = async (uri) => {
  const blob = await new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.onload = function onLoad() {
      resolve(xhr.response);
    };
    xhr.onerror = function onError(e) {
      reject(new TypeError('Network request failed'));
    };
    xhr.responseType = 'blob';
    xhr.open('GET', uri, true);
    xhr.send(null);
  });

  return blob;
};
export const abbrState = (input) => {
  const regions = states.concat(provinces, mexicoStates, peruStates);
  const normalizeRegion = (value = '') =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\./g, '')
      .trim()
      .toLowerCase();
  const regionAliases = {
    'ciudad de mexico': 'ciudad de mexico',
    'coahuila de zaragoza': 'coahuila',
    'estado de mexico': 'mexico',
    'huanuco province': 'huanuco',
    'lima province': 'lima',
    'mexico city': 'ciudad de mexico',
    'michoacan de ocampo': 'michoacan',
    'province of callao': 'callao',
    'province of lima': 'lima',
    'queretaro de arteaga': 'queretaro',
    'san martin region': 'san martin',
    'state of mexico': 'mexico',
    'veracruz de ignacio de la llave': 'veracruz',
  };
  const normalizedInput =
    regionAliases[normalizeRegion(input)] || normalizeRegion(input);
  let i;
  for (i = 0; i < regions.length; i++) {
    if (normalizeRegion(regions[i][0]) === normalizedInput) {
      return regions[i][1];
    }
  }
};
export const getEditFormDefaultValues = (post) => {
  const fields = { ...post };

  for (const key in fields) {
    if (typeof fields[key] === 'number') {
      fields[key] = fields[key].toString();
    } else {
      fields[key] = fields[key];
    }
  }

  delete fields.author;
  delete fields.createdAt;
  delete fields.photos;
  delete fields.includePhone;
  delete fields.updatedAt;

  return fields;
};

export const filterCars = (carData = [], filters) => {
  if (filters === undefined) {
    return carData; // Return the entire carData array if filters is undefined
  }
  // Check each filter condition
  return carData.filter(
    (car) =>
      (filters.bodyStyle.length === 0 ||
        filters.bodyStyle.includes(car.bodyStyle)) &&
      (filters.condition.length === 0 ||
        filters.condition.includes(car.condition)) &&
      (filters.fuel.length === 0 || filters.fuel.includes(car.fuel)) &&
      (filters.location === '' || filters.location === car.location) &&
      (filters.makes.length === 0 || filters.makes.includes(car.make)) &&
      (filters.model === '' ||
        filters.model?.toLowerCase() === car.model?.toLowerCase()) &&
      (filters.priceFrom === '' ||
        car.price >= parseFloat(filters.priceFrom)) &&
      (filters.priceTo === '' || car.price <= parseFloat(filters.priceTo)) &&
      (filters.sellerType === '' || filters.sellerType === car.sellerType) &&
      (filters.title.length === 0 || filters.title.includes(car.title)) &&
      (filters.transmission.length === 0 ||
        filters.transmission.includes(car.transmission)) &&
      (filters.yearFrom === '' || car.year >= parseInt(filters.yearFrom)) &&
      (filters.yearTo === '' || car.year <= parseInt(filters.yearTo)) &&
      (filters.zipCode === '' || filters.zipCode === car.location.zipCode) &&
      (filters.miles.every((item, i) => item === emptyFilterForm?.miles[i]) ||
        (Number(car.miles) >= filters.miles[0] &&
          filters.miles[1] === emptyFilterForm?.miles[1]) ||
        (Number(car.miles) >= filters.miles[0] &&
          Number(car.miles) <= filters.miles[1])),
  );
};
export const getDistance = (lat1, lon1, center) =>
  new Promise((resolve, reject) => {
    const currentLocation = window.navigator && window.navigator.geolocation;
    if (center) {
      const d = calculateDistance(lat1, lon1, center);
      resolve(Math.round(d));
    }
    if (currentLocation) {
      currentLocation.getCurrentPosition(
        (position) => {
          const loc = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          const d = calculateDistance(lat1, lon1, loc);
          resolve(Math.round(d));
        },
        (error) => {
          reject(error.message);
        },
      );
    }
  });
function calculateDistance(lat1, lon1, center) {
  const { lat: lat2, lng: lon2 } = center;
  const R = 6371; // Radius of the earth in km
  const dLat = deg2rad(lat2 - lat1); // deg2rad below
  const dLon = deg2rad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(deg2rad(lat1)) *
      Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) *
      Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
}
function deg2rad(deg) {
  return deg * (Math.PI / 180);
}

export function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export function getInitials(name) {
  if (typeof name !== 'string' || !name.trim()) {
    return '';
  }

  const words = name.split(' ');
  let initials = '';

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < words.length; i++) {
    const word = words[i];

    if (!word) {
      // eslint-disable-next-line no-continue
      continue;
    }

    initials += word[0].toUpperCase();

    if (initials.length >= 2) {
      break;
    }
  }

  return initials;
}
export const isFeatured = (data) => {
  if (!data.featuredPackage || !data?.featuredPackage?.expiresAt)
    return { ...data, isFeatured: false };
  const expiry = dayjs(data?.featuredPackage?.expiresAt);
  const now = dayjs().utc();
  const isExpired = now.isAfter(expiry);
  if (isExpired) {
    return { ...data, isFeatured: false };
  } else {
    return { ...data, isFeatured: true };
  }
};
export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const saveData = async (key, value) => {
  try {
    await localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    throw new Error(err);
  }
};

export const fetchData = async (key) => {
  try {
    const jsonValue = await localStorage.getItem(key);
    return jsonValue !== null ? JSON.parse(jsonValue) : null;
  } catch (err) {
    throw new Error(err);
  }
};

export const getLocation = async (code, country) => {
  const locationNotFoundMessage = i18n.t(
    'validation.locationNotFoundFromZipCode',
    'No location found from this zip code',
  );

  try {
    const COUNTRY = country || 'United States';
    const { results } = await fromAddress(`${COUNTRY} ${code?.trim()}`);
    const addressComponents = results[0]?.address_components;
    if (addressComponents?.length > 1) {
      const formattedAddress = results[0]?.formatted_address;
      const state = getAddress(
        addressComponents,
        'administrative_area_level_1',
      );
      const postalCode = getAddress(addressComponents, 'postal_code');
      const city = extractCity(formattedAddress);
      const coordinates = results[0]?.geometry.location;
      const { lat, lng } = coordinates;
      const location = {
        ...coordinates,
        zipCode: code?.trim(),
        hash: geohashForLocation([lat, lng]),
        formattedAddress: results[0]?.formatted_address,
        filteredAddress: `${postalCode}, ${abbrState(state)}`,
        country: COUNTRY,
        state,
        city,
      };
      return location;
    }
    throw new Error(locationNotFoundMessage);
  } catch (e) {
    if (e?.origin?.status) {
      throw new Error(locationNotFoundMessage);
    } else {
      throw new Error(e?.message || locationNotFoundMessage);
    }
  }
};
export const getLocationByDepartment = async (
  { department, district },
  country,
) => {
  const COUNTRY = country || 'United States';
  const districts = Array.isArray(district)
    ? district.filter(Boolean)
    : [district].filter(Boolean);

  const geocodeQuery = [districts[0] || department, department, COUNTRY]
    .filter(Boolean)
    .join(', ');

  let coordinates = { lat: null, lng: null, hash: null };
  try {
    const { results } = await fromAddress(geocodeQuery);
    const loc = results[0]?.geometry?.location;
    if (loc) {
      coordinates = {
        lat: loc.lat,
        lng: loc.lng,
        hash: geohashForLocation([loc.lat, loc.lng]),
      };
    }
  } catch (_) {
    // coordinates remain null if geocoding fails
  }

  return {
    country: COUNTRY,
    department: department || null,
    districts,
    filteredAddress: [department, districts.join(', ')]
      .filter(Boolean)
      .join(', '),
    ...coordinates,
  };
};
const getAddress = (addressComponents, type) => {
  const address = addressComponents.find(({ types }) => types.includes(type));
  return address?.long_name || '';
};
const extractCity = (formattedAddress) => formattedAddress.split(',')[0] || '';

const normalizeCountryName = (value = '') => value.trim().toLowerCase();
const normalizeLocationValue = (value = '') =>
  value.toString().trim().toLowerCase();
const getLocationDistricts = (location = {}) => {
  if (Array.isArray(location?.districts)) {
    return location.districts.filter(Boolean);
  }
  if (Array.isArray(location?.district)) {
    return location.district.filter(Boolean);
  }
  return [location?.district].filter(Boolean);
};
const matchDepartmentLocation = (postLocation = {}, selectedLocation = {}) => {
  const selectedDepartment = normalizeLocationValue(
    selectedLocation?.department,
  );

  if (!selectedDepartment) {
    return true;
  }

  if (normalizeLocationValue(postLocation?.department) !== selectedDepartment) {
    return false;
  }

  const selectedDistricts = getLocationDistricts(selectedLocation).map(
    normalizeLocationValue,
  );

  if (!selectedDistricts.length) {
    return true;
  }

  const postDistricts = getLocationDistricts(postLocation).map(
    normalizeLocationValue,
  );

  if (!postDistricts.length) {
    return false;
  }

  return selectedDistricts.some((district) => postDistricts.includes(district));
};

export async function fetchItems({ pageParam }, location, id, country) {
  const COUNTRY = country || 'United States';
  const LIMIT = 40;
  try {
    if (!location?.radius) {
      const queryRef = query(
        collection(firestore, 'posts'),
        where('category', '==', id || 'cars'),
        orderBy('createdAt', 'desc'),
      );

      const docs = await getDocs(queryRef);
      let data = await docs?.docs
        ?.map((doc) => doc.data())
        .filter((post) => {
          const postCountry = post?.location?.country || 'United States';
          return (
            normalizeCountryName(postCountry) === normalizeCountryName(COUNTRY)
          );
        });
      if (location?.department) {
        data = data.filter((post) =>
          matchDepartmentLocation(post?.location, location),
        );
      } else if (location?.lat && location?.lng) {
        data = data.filter(
          (post) =>
            post?.location?.lat === location.lat &&
            post?.location?.lng === location.lng,
        );
      }

      return new Promise((resolve) => {
        resolve({
          data: data.slice(pageParam, pageParam + LIMIT),
          currentPage: pageParam,
          nextPage: pageParam + LIMIT < data.length ? pageParam + LIMIT : null,
        });
      });
    }
    const payload = await request({
      url: '/searchByLocation',
      method: 'POST',
      data: {
        pageParam,
        location,
        id,
        country: COUNTRY,
        limit: LIMIT,
      },
    });
    return payload;
  } catch (error) {
    throw new Error(error);
  }
}
export const isValidCountryCode = (code) =>
  code &&
  COUNTRIES.some(
    (country) => country.code.toLowerCase() === code.toLowerCase(),
  );

export const ensureUserCountryInFirebase = async (
  uid,
  fallbackCountry = 'United States',
) => {
  if (!uid) return null;

  try {
    const userDocRef = doc(firestore, 'users', uid);
    const userSnap = await getDoc(userDocRef);

    if (!userSnap.exists()) {
      return null;
    }

    const existingCountry = userSnap.data()?.country;
    const normalizedCountry =
      typeof existingCountry === 'string' ? existingCountry.trim() : '';

    if (!normalizedCountry) {
      await setDoc(userDocRef, { country: fallbackCountry }, { merge: true });
      return fallbackCountry;
    }

    return existingCountry;
  } catch (error) {
    console.error('Failed to ensure user country:', error);
    return fallbackCountry;
  }
};

export const isIpAddress = (hostname) => {
  const ipv4 = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6 = /^[\da-f:]+$/i;
  return ipv4.test(hostname) || ipv6.test(hostname);
};
export const getCountryFromDomain = (
  hostname = window?.location?.hostname || '',
) => {
  const GENERIC_COUNTRY_CODE = 'US';
  const parts = hostname.replace(/^www\./, '').split('.');
  if (!hostname || hostname === 'localhost' || isIpAddress(hostname)) {
    return GENERIC_COUNTRY_CODE;
  }
  const tld = parts[parts.length - 1].toLowerCase();
  if (genericTlds.has(tld)) return GENERIC_COUNTRY_CODE;
  return tld;
};

export const detectCountryByIp = async () => {
  try {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 5000);
    const res = await fetch('https://ipapi.co/json/', {
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    if (!res.ok) return null;
    const data = await res.json();
    return data?.country_code ? data.country_code.toUpperCase() : null;
  } catch (err) {
    console.warn('detectCountryByIp: failed to resolve country from IP', err);
    return null;
  }
};
